export default __webpack_public_path__ + "static/media/profileImg.198cca8c.svg";